export default __webpack_public_path__ + "static/media/bg-login-page.1821ded4.svg";